import { render, staticRenderFns } from "./GeneralSettingsTaxesIgnoreShippingType.vue?vue&type=template&id=465ee6af&"
import script from "./GeneralSettingsTaxesIgnoreShippingType.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTaxesIgnoreShippingType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports